// add/remove from wishlist
(() => {

    const preload = new Image();
    preload.src = "https://cdn.shopify.com/s/files/1/0353/7249/files/heartanimationresize2.png";
    const customerInput = document.getElementById("customer-id-input");
    const productInput = document.getElementById("product-id-input");
    const customerId = customerInput?.value;
    const productId = productInput?.value;
    const KLAVIYO_PUBLIC_KEY = "yKULaH";
    const emailInput = document.getElementById("customer-email-input");
    const customerEmail = emailInput?.value;

    const imgEle = document.createElement("div");
    imgEle.className = "wishlist-animation w-full h-full heartAnimate"
    const regularEle = document.createElement("img");
    regularEle.src="https://cdn.shopify.com/s/files/1/0353/7249/files/Heart_FILL_1.png?v=1761659296"
    regularEle.style.height = "40px";
    regularEle.style.width = "50px";
    const fullHeartImage = document.createElement("img");
    fullHeartImage.src = "https://cdn.shopify.com/s/files/1/0353/7249/files/Heart_FILL.png?"
    fullHeartImage.style.height="40px";
    fullHeartImage.style.width="50px"

    const params = new URLSearchParams(window.location.search);
    const isRedirect = params.get('wishlist');

    if (isRedirect) {
        if (!productId) {
            return
        }
        fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/add-product", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    customerId: customerId,
                    productId: productId,
                    shopId: "3537249"
                }),
                mode: "cors"
            })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    wishlistPath?.setAttribute("fill", "#f00f83")
                    wishlistPath?.setAttribute("stroke", "#f00f83")
                    wishlistSelector?.classList.remove("add-to-wishlist")
                    wishlistSelector?.classList.add("remove-from-wishlist")
                } else {
                    console.log("failed to add to wishlist")
                }
            })
    }

const klaviyoTrack = (type, product, customerEmail, length) => {
  const eventName = type === "add" ? "Added to Wishlist" : "Removed from Wishlist";

  const eventProperties = {
    "Product Title": product.title,
    "Product ID": product.id,
    "Item Price": product.price / 100,
    "CompareAtPrice": product.compare_at_price ? product.compare_at_price / 100 : null,
    "Wishlist Total Items": length,
    "ImageUrl": product.featuredImage.url?.split("?")[0] || product.featured_image.split("?")[0],
    "Product Url": `https://www.myoddballs.com/products/${product.handle}`,
    "Wishlist URL": "https://www.myoddballs.com/pages/wishlist"
  };

  window._learnq = window._learnq || [];

  if (customerEmail) {
    window._learnq.push([
      'identify',
      { $email: customerEmail }
    ]);
  }

  window._learnq.push(['track', eventName, eventProperties]);
};

    document.addEventListener("click", (e) => {

        if (e.target.closest(".open-wishlist-popup")) {
            event.stopPropagation();
            event.preventDefault();
            const popup = document.getElementById("wishlist-popup");
            openPopup(popup)
        }
        if (e.target.closest(".remove-from-wishlist")) {
            const wishlistSelector = e.target.closest(".remove-from-wishlist")
            const wishlistPath = wishlistSelector?.querySelector("path")
                        let prodInfo;
            let productPageInput = document.getElementById("product-json");
            if (productPageInput){
                prodInfo = JSON.parse(productPageInput.value)
            }else{
                if(e.target.closest(".product-card")){

                    prodInfo = JSON.parse(e.target.closest(".product-card").querySelector(".prod-info").value);
                }else{
                    prodInfo = JSON.parse(e.target.closest(".wishlist-card").querySelector(".prod-info").value);
                }
            }
            let prodToUse = productId
            if (!prodToUse) {
                prodToUse = wishlistSelector.dataset.id
            }
            wishlistSelector?.classList.add("add-to-wishlist")
            wishlistSelector?.classList.remove("remove-from-wishlist")
            wishlistSelector.innerHTML = regularEle.outerHTML
            event.stopPropagation();
            event.preventDefault();
            fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/remove-product", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        productId: prodToUse,
                        shopId: "3537249"
                    }),
                    mode: "cors"
                })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        
                        const length = data.updatedList.length
                        klaviyoTrack("remove", prodInfo, customerEmail, length);
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                });


        }
        if (e.target.closest(".add-to-wishlist")) {
            const wishlistSelector = e.target.closest(".add-to-wishlist")
            let prodInfo;
            let productPageInput = document.getElementById("product-json");
            if (productPageInput){
                prodInfo = JSON.parse(productPageInput.value)
            }else{
                if(e.target.closest(".product-card")){

                    prodInfo = JSON.parse(e.target.closest(".product-card").querySelector(".prod-info").value);
                }else{
                    prodInfo = JSON.parse(e.target.closest(".wishlist-card").querySelector(".prod-info").value);
                }
            }
            let prodToUse = productId
            if (!prodToUse) {
                prodToUse = wishlistSelector.dataset.id
            }
            wishlistSelector?.classList.remove("add-to-wishlist")
            wishlistSelector?.classList.add("remove-from-wishlist")
            wishlistSelector.innerHTML = imgEle.outerHTML;
            event.stopPropagation();
            event.preventDefault();
            fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/add-product", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        productId: prodToUse,
                        shopId: "3537249"
                    }),
                    mode: "cors"
                })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        
                        const length = data.updatedList.length
                        klaviyoTrack("add", prodInfo, customerEmail, length);
                    }else{
                        throw new Error('error adding to wishlist')
                    }
                })
                .catch((err) => {
                    const errorDiv = document.createElement("div");
                    errorDiv.className = "fixed top-4 right-4 bg-red text-white rounded-md p-2 text-center" ;
                    errorDiv.innerHTML("sorry there was an error adding to wishlist");
                    document.body.appendChild(errorDiv)
                    setTimeout(()=>{
                        errorDiv.remove()
                    },2000)
                    console.error("Error:", err);
                });


        }
        if (e.target.closest(".remove-from-wishlist-item")) {
            const wishlistSelector = e.target.closest(".remove-from-wishlist-item")
            let prodInfo;
            let productPageInput = document.getElementById("product-json");
            if (productPageInput){
                prodInfo = JSON.parse(productPageInput.value)
            }else{
                if(e.target.closest(".product-card")){

                    prodInfo = JSON.parse(e.target.closest(".product-card").querySelector(".prod-info").value);
                }else{
                    prodInfo = JSON.parse(e.target.closest(".wishlist-card").querySelector(".prod-info").value);
                }
            }
            let prodToUse = productId
            if (!prodToUse) {
                prodToUse = wishlistSelector.dataset.id.replace("gid://shopify/Product/","")
            }
            wishlistSelector?.classList.add("add-to-wishlist")
            wishlistSelector?.classList.remove("remove-from-wishlist")
            wishlistSelector.innerHTML = regularEle.outerHTML;
            event.stopPropagation();
            event.preventDefault();
            fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/remove-product", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        productId: prodToUse,
                        shopId: "3537249"
                    }),
                    mode: "cors"
                })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        getWishlist()
                        klaviyoTrack("remove", prodInfo, customerEmail, length);
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                });


        }
    })




    //display wishList;
    const currencySymbol = document.body.getAttribute("currency-symbol")
    var currentDate = new Date();
    var currentMonth = currentDate.toLocaleString('en-US', {
        month: 'short'
    }).toLowerCase();
    const market = document.body.getAttribute("market") === 'eu' ? 'eu' : 'uk';
    const marketTag = `country-${market}`;
    const getWishlist = async () => {

        const wishlistContainer = document.getElementById("wishlist-product-container");
        if (!wishlistContainer) {
            return
        }
        const customerInput = document.getElementById("customer-id-input");
        const customerId = customerInput?.value;
        if (!customerId) {
            console.error("no customer id found");
            return
        }
        const url = `https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/get-wishlist?customerId=${customerId}`;
        const res = await fetch(url);
        const data = await res.json()
        wishlistContainer.innerHTML = "";
        if(data.length == 0){
            wishlistContainer.className = "flex flex-col items-center w-full justify-center py-2 gap-2"
            wishlistContainer.innerHTML = "There's nothing here yet"
            const continueShoppingEle = document.createElement("a");
            continueShoppingEle.href="/"
            const continueShoppingWrapper = document.createElement("div");
            continueShoppingWrapper.classList = "w-full flex justify-center";
            continueShoppingWrapper.appendChild(continueShoppingEle);
            continueShoppingEle.className = "px-4 py-2 border border-magenta-500 text-magenta border-solid text-cetner rounded-md";
            continueShoppingEle.innerHTML = "Start Shopping"
            wishlistContainer.appendChild(continueShoppingWrapper)
        }
        data.forEach((product, index) => {
            generateProductHtml(product, index, currentMonth, false, wishlistContainer)
        })
    }
    getWishlist();




    document.addEventListener("click", () => {
        if (event.target.closest('.wish-list-quick-add')) {
            if (window.ThemeType == "B") {
                // NEW SYSTEM: Use buildQb directly
                const wrapper = event.target.closest('.wishlist-card');
                const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
                // Prevent the old system from running by adding a flag
                wrapper.setAttribute('data-using-new-qb', 'true');
                buildQb(prod);
            } else {
                // OLD SYSTEM: Use existing showWishlistQbPopup
                const wrapper = event.target.closest('.wishlist-card');
                // Check if new system is already running
                if (wrapper.getAttribute('data-using-new-qb') === 'true') {
                    return; // Don't run old system if new one is active
                }
                event.target.closest(".quick-add-wrapper").classList.add("qb-loading");
                const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
                showWishlistQbPopup(prod)
            }
        }
    })


    function showWishlistQbPopup(product, view = "qb") {
        const currency = document.body.getAttribute("currency");

        let countryUrl = document.body.getAttribute("country-url");
        countryUrl = (countryUrl == "/") ? "" : "";
        product.url = "https://www.myoddballs.com/products/" + product.handle

        // Construct view parameter with proper format
        const viewParam = `?view=${view}&currency=${currency}`;
        let url = countryUrl + product.url + viewParam;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.text();
            })
            .then(data => {
                const loaders = document.querySelectorAll('.qb-loading');
                loaders.forEach(item => {
                    item.classList.remove("qb-loading");
                })
                const qbLoc = document.getElementById("default-quick-buy-content");
                qbLoc.innerHTML = data;
                const qbPopup = document.getElementById("default-quick-buy-popup-content");
                openPopup(qbPopup);
            })

    }

    const heartSvg = `<img src="https://cdn.shopify.com/s/files/1/0353/7249/files/Heart_FILL.png" style="height:40px; width:50px">`

    const generateProductHtml = (product, index, currentMonth, searchPage, target) => {
        try {
            const prodAvailable = product.variants.edges.some((item) => {
                return item.node.availableForSale
            })
            product.price = product?.priceRangeV2?.maxVariantPrice?.amount;
            if (false) {
                const saleTag = product.tags1.find((tag) => {
                    return tag.includes("lw-")
                })
                let saleAmount = Number(saleTag?.split("-").pop()) || 0;

                product.price = product.price * (1 - (saleAmount / 100));
            }
            product.listPrice = product?.compareAtPriceRange?.maxVariantCompareAtPrice?.amount || product?.priceRangeV2?.maxVariantPrice?.amount;
            let proceed = prodAvailable || product.tags.includes("show-out-of-stock-sold-out");
            proceed = proceed && !product.tags.includes("hide-me") &&
                (product.tags.includes(marketTag) || !product.tags.some(tag => tag.startsWith("country-")));
            let tagsProceed = !product.tags.includes("hide-me") &&
                (product.tags.includes(marketTag) || !product.tags.some(tag => tag.startsWith("country-")));

            if (product.alternateImageUrls) {
                product.alternateImageUrls.unshift(product.imageUrl);
            }
            product.alternateImageUrls = product.media.edges.map((image) => {
                return image.node.preview.image.url
            })
            const tempProdImages = product.alternateImageUrls ? product.alternateImageUrls : [product.featuredImage.url];

            let prodImages = tempProdImages.filter((url) => {
                let toReturn = true;
                let matchString = ("month-" + currentMonth);
                toReturn = url.toLowerCase().includes("month-") ? url.toLowerCase().includes(matchString) : true;
                toReturn = toReturn && (url.toLowerCase().includes("sub-") ? url.toLowerCase().includes("sub-collection") : true);
                return toReturn;
            });
            const productCard = document.createElement('div');
            // Add unique identifier using product ID
            productCard.setAttribute('data-product-id', product.id.replace("gid://shopify/Product/", ""));
            productCard.classList.add("wishlist-card", "flex", "flex-col", "relative");
            let tags = product.tags;
            if (tags.includes("design-cookie-monster") && false) {
                productCard.classList.add("cookie-monster-product")
            }
            //card_index+=;
            const imageWrapper = document.createElement('div');
            imageWrapper.classList.add("product-card__image-wrapper");
            const heartSvgEle = document.createElement("div");
            heartSvgEle.className = "absolute top-4 left-4 z-10 remove-from-wishlist-item";
            heartSvgEle.dataset.id = product.id
            heartSvgEle.innerHTML = heartSvg;
            productCard.append(heartSvgEle);
            const productLink = document.createElement('a');
            productLink.id = "collection-product-link-" + (index + 1)
            productLink.href = "https://www.myoddballs.com/products/" + product.handle;
            productLink.classList.add("swiper", "swiper-product", "product-card__image", "group", "aspect-square", "swiper-initialized", "swiper-horizontal", "swiper-ios", "swiper-backface-hidden");

            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add("swiper-wrapper");
            swiperWrapper.setAttribute("aria-live", "polite");

            const imageSlide = document.createElement('div');
            imageSlide.classList.add("swiper-slide", "swiper-slide-active", "flex", "items-center");
            imageSlide.setAttribute("role", "group");
            imageSlide.setAttribute("aria-label", "1 / 1");


            const productImage = document.createElement('img');
            productImage.classList.add("w-full", "front-image");
            productImage.src = prodImages[0] ? prodImages[0] : product.featuredImage.url;
            productImage.sizes = "(min-width: 720px) 25vw, 50vw"
            productImage.srcset = modifyUrlWithResolutions(prodImages[0] ? prodImages[0] : product.featuredImage.url);
            if (index > 4) {
                productImage.loading = "lazy";
            } else {
                productImage.loading = "eager";
            }
            productImage.alt = product.title;
            productImage.width = 500;
            productImage.height = 500;

            let backImg = prodImages[1];

            const backImage = document.createElement('img');
            backImage.classList.add("w-full", "opacity-0", "back-image", "absolute", "top-0", "bottom-0");
            backImage.src = backImg ? backImg : product.featuredImage.url;
            backImage.srcset = modifyUrlWithResolutions(backImg ? backImg : product.featuredImage.url);
            backImage.loading = "lazy";
            backImage.alt = product.title;

            imageSlide.appendChild(productImage);
            imageSlide.appendChild(backImage);
            swiperWrapper.appendChild(imageSlide);
            productLink.appendChild(swiperWrapper);
            imageWrapper.appendChild(productLink);

            const labelLoc = document.createElement('div');
            labelLoc.className = "label-loc";
            labelLoc.classList.add("text-xxs");
            productCard.appendChild(imageWrapper);
            productCard.appendChild(labelLoc);

            // Quick add button
            const quickAddWrapper = document.createElement('div');
            quickAddWrapper.className = "bg-gray-100 justify-center p-3";
            const quickAddDiv = document.createElement('div');
            const bisSignup = document.createElement('div');
            bisSignup.className = "rounded-full border border-black border-solid flex justify-center items-center text-center w-full bg-white sm:max-w-[90%] mx-auto py-2 text-xxs md:text-xs klaviyo-bis-trigger uppercase";
            bisSignup.innerHTML = "Sign up to back in stock"
            if (prodAvailable) {
                quickAddWrapper.append(quickAddDiv);
            } else {
                quickAddWrapper.append(bisSignup);
            }
            quickAddDiv.className = "rounded-full border border-black border-solid grid grid-cols-2 w-full bg-white sm:max-w-[90%] mx-auto";

            let gridType = (searchPage) ? "search-page-" : "collection-";

            const seeMoreDiv = document.createElement('a');
            seeMoreDiv.id = gridType + "see-more-" + (index + 1)
            seeMoreDiv.href = "https://www.myoddballs.com/products/" + product.handle;
            seeMoreDiv.className = "text-xxs md:text-xs items-center text-center uppercase border-r border-solid border-gray-300 py-2 md:py-2 font-semibold md:font-normal";
            seeMoreDiv.innerText = translations.collections.see_more;
            quickAddDiv.append(seeMoreDiv);

            const quickAddLoader = document.createElement('div');
            quickAddLoader.className = "w-4 quick-buy-loader";
            quickAddLoader.innerHTML = GEBO.helpers.loader;

            const quickAddButton = document.createElement('div');
            quickAddButton.id = gridType + "quick-buy-" + (index + 1)
            quickAddButton.className = "event-quickbuy-show quick-add-wrapper text-xxs md:text-xs items-center text-center uppercase wish-list-quick-add py-2 font-semibold md:font-normal relative md:py-2 flex justify-center";
            quickAddButton.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
            const quickBuyDiv = document.createElement('div');
            quickBuyDiv.className = "quick-buy-text";
            quickBuyDiv.innerHTML = translations.collections.quick_buy;
            quickBuyDiv.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
            quickAddButton.append(quickBuyDiv);

            // Create padding div and append it correctly
            const qbPadding = document.createElement('div');
            qbPadding.className = "absolute left-0 wish-list-quick-add z-2";
            qbPadding.style.top = "-50%";
            qbPadding.style.width = "120%";
            qbPadding.style.height = "195%";
            qbPadding.setAttribute('data-handle', product.handle);
            qbPadding.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
            quickAddButton.append(qbPadding);
            quickAddButton.append(quickAddLoader);
            quickAddDiv.append(quickAddButton);

            // Product details
            const productDetails = document.createElement('div');
            productDetails.append(quickAddWrapper);
            productDetails.classList.add("product-card__details", "sm:px-0", "h-full", "pb-2");

            const productTitleLink = document.createElement('a');
            productTitleLink.id = "collection-product-title-" + (index + 1)
            productTitleLink.classList.add("h-full", "flex", "flex-col", "justify-between");
            productTitleLink.href = "https://www.myoddballs.com/products/" + product.handle;
            let titleInfo = titleLogic(product);

            const productTitle = document.createElement('p');
            productTitle.classList.add("product-card__details__title", "px-2", "text-base", "font-semibold");
            productTitle.textContent = String(titleInfo['cleanTitle']);

            const productTitleWrap = document.createElement('div');

            const productCategory = document.createElement('p');
            productCategory.classList.add("product-card__details__color", "px-2");
            productCategory.textContent = String(titleInfo['subTitle']);

            const productPrice = document.createElement('p');
            productPrice.classList.add("product-card__details__price", "px-2", "text-magenta-500", "text-md");
            let price = product.price;
            let listPrice = product.listPrice;
            if (listPrice % 1 !== 0) {
                listPrice = parseFloat(listPrice).toFixed(2);
            } else {
                listPrice = Math.floor(listPrice)
            }
            if (price % 1 !== 0) {
                price = parseFloat(price).toFixed(2);
            } else {
                price = Math.floor(price)
            }
            const normalPrice = currencySymbol + `${price}`;
            const listPriceElement = Number(product.listPrice) > Number(product.price) ?
                `<del class="ml-1 text-gray-400">${currencySymbol}${listPrice}</del>` :
                `<del class="ml-1 text-gray-400 hidden">${currencySymbol}${listPrice}</del>`;
            productPrice.innerHTML = `${normalPrice}${listPriceElement}`;

            const productPriceWrap = document.createElement('div');

            productTitleWrap.append(productTitle, productCategory);
            productPriceWrap.append(productPrice);
            productTitleLink.append(productTitleWrap, productPriceWrap);

            productDetails.appendChild(productTitleLink);
            productCard.appendChild(productDetails);

            const prodInfo = document.createElement('input');
            prodInfo.setAttribute("type", "hidden");
            prodInfo.setAttribute("value", JSON.stringify(product));
            prodInfo.classList.add("prod-info");
            productCard.appendChild(prodInfo);
            //christmas message
            const christmas_banner_element = document.getElementById('christmas_banner_metaobject_collection');
            if (christmas_banner_element) {
                const christmas_banner_content = christmas_banner_element.innerHTML; // Use innerHTML for HTML content
                // Append HTML content to productCard
                productCard.innerHTML += christmas_banner_content;
            }
            target.append(productCard);

        } catch (error) {
            console.error("Error adding: " + product.name);
            console.error("Error: " + error);
        }
    }

    function modifyUrlWithResolutions(url) { // used to return a source set with multiple resolutions
        var resolutions = [360, 420, 480, 640, 840, 1080, 1280, 1540, 1860, 1950];
        var parts = url.split('.');
        var fileName = parts.slice(0, -1).join('.');
        var fileExtension = parts[parts.length - 1];
        var modifiedUrls = [];

        for (var i = 0; i < resolutions.length; i++) {
            var resolution = resolutions[i];
            var modifiedUrl = fileName + "_" + (resolution / 4) + "x." + fileExtension + " " + resolution / 4 + "w";
            modifiedUrls.push(modifiedUrl);
        }

        var result = '';
        for (var j = 0; j < modifiedUrls.length; j++) {
            result += modifiedUrls[j];
            if (j !== modifiedUrls.length - 1) {
                result += ',';
            }

        }
        //return("")
        return result;
    }

    function titleLogic(product) {
        try {
            // Initial validation with detailed error
            if (!product) {
                return {
                    cleanTitle: '',
                    subTitle: '',
                    onSale: false
                };
            }

            if (!product.title) {
                return {
                    cleanTitle: '',
                    subTitle: '',
                    onSale: false
                };
            }

            let title = product.title;
            let cleanTitle = title;
            let subTitle = '';
            let onSale = false;

            try {
                // Safely check if product is on sale
                onSale = Boolean(product.compare_at_price > product.price);
            } catch (priceError) {
                onSale = false;
            }

            try {
                // Handle subscription products
                if (title.toLowerCase().includes("subscription") && !title.toLowerCase().includes("pre-paid") && false) {
                    try {
                        let tags = Array.isArray(product.tags1) ? product.tags1 : [];
                        let temp = title.split("-");

                        for (let each of temp) {
                            if (each && each.toLowerCase().includes("sock")) {
                                cleanTitle = each.replace("& Sock", "& free sock");
                            }
                        }

                        if (tags.includes('subscription_classic')) {
                            subTitle = 'Plain Monthly Subscription';
                        } else if (tags.includes('subscription-patterned')) {
                            subTitle = "Patterned Monthly Subscription";
                        }
                    } catch (subscriptionError) {
                        console.error('titleLogic: Error processing subscription:', subscriptionError);
                    }
                }
                // Handle pre-paid products 
                else if (title.toLowerCase().includes("pre-paid")) {
                    try {
                        let tags = Array.isArray(product.tags1) ? product.tags1 : [];

                        if (tags.includes('subscription_classic')) {
                            subTitle = ' Plain Subscription';
                        } else if (tags.includes('subscription_adventurous')) {
                            subTitle = ' Patterned Subscription';
                        }

                        if (title.includes('06 Month Pre-Paid: ')) {
                            try {
                                cleanTitle = subTitle.replace('', '6 month pre-paid ');
                                title = title.replace('06 Month Pre-Paid: ', '')
                                    .replace('CLASSIC Subscription - ', '')
                                    .replace('[G2]', '')
                                    .replace(' monthly subscription', '')
                                    .toLowerCase();
                            } catch (sixMonthError) {
                                console.error('titleLogic: Error processing 6-month pre-paid:', sixMonthError);
                            }
                        } else if (title.includes('12 Month Pre-Paid: ')) {
                            try {
                                cleanTitle = subTitle.replace('', '12 month pre-paid ');
                                title = title.replace('12 Month Pre-Paid: ', '')
                                    .replace('CLASSIC Subscription - ', '')
                                    .replace('[G2]', '')
                                    .replace(' monthly subscription', '')
                                    .toLowerCase();
                            } catch (twelveMonthError) {
                                console.error('titleLogic: Error processing 12-month pre-paid:', twelveMonthError);
                            }
                        }
                    } catch (prePaidError) {
                        console.error('titleLogic: Error processing pre-paid subscription:', prePaidError);
                    }
                }
                // Handle regular products
                else {
                    try {
                        if (cleanTitle && cleanTitle.includes('-')) {
                            let cleanTitleArr = cleanTitle.split(' - ');
                            let cleanTitleFirst = cleanTitleArr[0] + ' - ';
                            subTitle = cleanTitle.replace(cleanTitleFirst, '');
                            cleanTitle = cleanTitleFirst.replace(' - ', '');
                        }
                    } catch (regularProductError) {
                        console.error('titleLogic: Error processing regular product:', regularProductError);
                    }
                }
            } catch (mainLogicError) {
                console.error(mainLogicError)
            }

            // Ensure clean return values
            return {
                cleanTitle: cleanTitle || '',
                subTitle: subTitle || '',
                onSale: Boolean(onSale)
            };

        } catch (globalError) {
            console.error('titleLogic: Critical error in title processing:', globalError);
            return {
                cleanTitle: product?.name || '',
                subTitle: '',
                onSale: false
            };
        }
    }



})()